import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { EditSetupDoor } from '~/features/setup-studio/edit/edit-door';

/**
 * Edit the setup: the setup frame over the workspace that is open, for its
 * primary admin; anybody else gets the setup read-only with Suggest a change
 * (9.18). Opened from the Business map (`?from=map`), its ways out go back to
 * the map (docs/plans/business-map.md, S10).
 */
const search = z.object({
  from: z.enum(['map']).optional(),
});

export type EditSetupSearch = z.infer<typeof search>;

export const Route = createFileRoute('/onboarding/edit/')({
  validateSearch: search,
  component: EditSetupDoor,
});
